<template>
  <div>
    <Header >
      <div class="header-buttons">
        <div v-if="isAdmin" class="register-btn-container">
          <a v-if="!loading && isPamplonaCompanyAdmin" class="header-button" style="margin-right: 10px; display: flex; align-items: center;" title="BI" :href="pamplonaBiUrl" target="_blank">
            BI
          </a>

          <a v-if="loading" style="cursor: not-allowed;" class="header-icon">
            <img style="margin: 0; color: white;" src="./../assets/plus.svg"/>
            <div class="dropdown-menu"></div>
          </a>
        </div>

        <div class="history-buttons" >
          <router-link :to="'/feed-inventory'" v-if="!loading && showFeedInventoryLink">
            <button class="header-button" title="Estoque de ração — todos os galpões">
              <img class="feed-header-icon" src="./../assets/ico-feed.svg" alt="" />
              Estoque de Ração
            </button>
          </router-link>

          <router-link :to="'/feed-inventory'" v-if="!loading && showFeedInventoryLink && loadingTotal == 0">
            <button class="header-icon" title="Estoque de ração — todos os galpões">
              <img class="feed-mobile-icon" src="./../assets/ico-feed.svg" alt="Estoque de Ração" />
            </button>
          </router-link>

          <button
            style="cursor: not-allowed;"
            class="header-icon"
            v-if="loading && showFeedInventoryLink"
            title="Estoque de ração — todos os galpões"
          >
            <img class="feed-mobile-icon" src="./../assets/ico-feed.svg" alt="Estoque de Ração" />
          </button>

          <button
            class="header-button history-disabled"
            v-if="loading && showFeedInventoryLink"
            title="Estoque de ração — todos os galpões"
          >
            <img class="feed-header-icon" src="./../assets/ico-feed.svg" alt="" />
            Estoque de Ração
          </button>

          <router-link class="company-users-link" :to="'/list-users'" v-if="!loading && showCompanyUsersLink">
            <button type="button" class="header-button" title="Usuários da empresa">
              Usuários
            </button>
          </router-link>

          <router-link class="company-users-link" :to="'/list-users'" v-if="!loading && loadingTotal == 0 && showCompanyUsersLink">
            <button type="button" class="header-icon" title="Usuários da empresa">
              <i class="fas fa-users users-header-icon"></i>
            </button>
          </router-link>

          <router-link :to="'/batches-history'" v-if="!loading">
            <button class="header-button" title="Ir para histórico de lotes" >
              Histórico de lotes
            </button>
          </router-link>

          <router-link :to="'/batches-history'" v-if="!loading && loadingTotal == 0">
            <button class="header-icon" title="Ir para histórico de lotes">
              <img class="history-icon" src="./../assets/history-icon.svg"/>
            </button>
          </router-link>

          <button style="cursor: not-allowed;" class="header-icon" v-if="loading" title="Ir para histórico de lotes">
            <img class="history-icon" src="./../assets/history-icon.svg"/>
          </button>

          <button class="header-button history-disabled" v-if="loading" title="Ir para histórico de lotes">
            Histórico de lotes
          </button>
        </div>
        <form class="farm-dropdown" v-if="userLevel == 'pecsmart'">
          <select name="comapanies" v-model="optionCompanies" class="select-companies" :class="colorSelectCompanies">
            <option>Companies</option>
            <option :key="company.pk" v-for="company in companies" :value="company">
              {{company.name}}
            </option>
          </select>
        </form>
        <form class="farm-dropdown">
          <div>
            <select  v-if="userLevel === 'pecsmart'" name="granjas" v-model="optionFarmPecsmart" :class="colorSelectFarm">
              <option >Pecsmart Support</option>
              <option >Todas as Granjas</option>
              <option v-bind:key="farm.id" :value="farm" v-for="farm in allFarms">
                {{farm.name}}
              </option>
            </select>
            <select v-else name="granjas" v-model="optionFarm">
              <option >Todas as Granjas</option>
              <option v-bind:key="farm.id" v-for="farm in allFarms" :value="farm">
                {{farm.name}}
              </option>
            </select>
          </div>
        </form>
      </div>
    </Header>
    <PageLoader
      v-if="loading"
      :showWelcomeText="true"
      welcomeText="PecSmart Transformação Digital para o Campo ..."
    />
    <transition name="content-reveal">
      <div v-show="!loading" class="container page-animation">
        <div class="row">
          <div class="col-lg-12 home-content-wrapper">
            <div
              class="message"
              v-if="selectedFarms.length === 0 && userLevel == 'pecsmart'"
            >
              Selecione uma fazenda ou uma empresa
            </div>

            <template v-for="(farm, index) in selectedFarms">
              <div
                v-if="isSiloHomeFarm(farm)"
                :key="'silo-' + farm.id"
                class="farms-silos-section"
              >
                <FarmSilosGroup
                  :farm="farm"
                  :company="company"
                  :defer-load="index > 0"
                />
              </div>

              <div
                v-else
                :key="'farm-' + farm.id"
                class="conteudo galpoes"
              >
                <Farm v-bind:farm="farm" :company="company"/>
              </div>
            </template>

            <Copyright />
          </div>
        </div>
      </div>
    </transition>

    <ModalStyle>
      <RegisterFarmModal v-if="showModalFarm" @close="closeModal()" />
      <EditFarmAltModal v-bind:allFarms="allFarms" v-if="showModalEditFarm" @close="showModalEditFarm = false" />
      <RegisterBarnAltModal v-bind:allFarms="allFarms" v-if="showModalBarn" @close="closeModal()" />
    </ModalStyle>
  </div>
</template>

<script>
import PageLoader from "../components/Loader.vue";
import Farm from "../components/FarmV2.vue";
import Copyright from "../components/Copyright.vue";
import Header from "../components/Header.vue";
import RegisterFarmModal from "../components/RegisterFarmModal.vue";
import RegisterBarnAltModal from "../components/RegisterBarnAltModal.vue";
import ModalStyle from "../components/ModalStyle.vue";
import EditFarmAltModal from "../components/EditFarmAltModal.vue";
import FarmSilosGroup from "../components/FarmSilosGroup.vue";
import {
  getFarmPk,
  isSiloHomeEnabledForFarm,
} from "../utils/siloHomeVisibility";
import { canManageCompanyUsers } from "../utils/companyUsers";
import { isFeedInventoryOnly, resolveFeedInventoryAccess } from "../utils/feedInventoryAccess";

export default {
  name: "HomePage",
  beforeRouteEnter(to, from, next) {
    to.meta.title = "PecSmart - Início";
    document.title = to.meta.title;
    next();
  },
  components: {
    Farm,
    Copyright,
    Header,
    RegisterFarmModal,
    RegisterBarnAltModal,
    ModalStyle,
    PageLoader,
    EditFarmAltModal,
    FarmSilosGroup,
  },
  data() {
    return {
      loading: true,
      showModalBarn: false,
      showModalFarm: false,
      showModalEditFarm: false,
    }
  },
  async created() {
    if (this.feedInventoryOnly) {
      this.$router.replace('/feed-inventory')
      return
    }
    if (this.status === true) {
      this.loading = false
      return
    }
    await this.bootstrapHomeData()
    if (this.feedInventoryOnly) {
      this.$router.replace('/feed-inventory')
      return
    }
    this.loading = false
  },
  computed: {
    allFarms() {
      this.$store.dispatch("setSelectedFarms", this.$store.getters.getAllFarms)
      return this.$store.getters.getAllFarms
    },
    status() {
      return this.$store.getters.getLogedIn;
    },
    isAdmin() {
      return this.$store.getters.getIsAdmin;
    },
    company(){
      return this.$store.getters.getCurrentUser.company
    },
    companies() {
      return this.$store.getters.getCompanies
    },
    companySettings() {
      return this.$store.getters.getCompanySettings;
    },
    showSiloHome() {
      return this.companySettings?.settings?.client_frontend?.show_silo_home ?? false;
    },
    showFeedInventoryLink() {
      return resolveFeedInventoryAccess(
        this.$store.getters.getCurrentUser,
        this.companySettings,
      ).allowed
    },
    feedInventoryOnly() {
      return isFeedInventoryOnly(
        this.$store.getters.getCurrentUser,
        this.companySettings,
      )
    },
    showCompanyUsersLink() {
      return canManageCompanyUsers(
        this.$store.getters.getCurrentUser,
        this.companySettings,
      )
    },
    selectedFarms() {
      const optionType = this.userLevel !== 'pecsmart' ? this.optionFarm : this.optionFarmPecsmart

      if (this.optionFarmPecsmart == 'Todas as Granjas') return this.allFarms
      if (this.optionFarm == 'Todas as Granjas' && this.userLevel !== 'pecsmart') return this.allFarms
      if (this.userLevel !== 'pecsmart') return this.filterFarm(optionType)
      return this.showByFarm ? this.filterFarm(optionType) : this.filterCompanies(this.optionCompanies)
    },
    colorSelectFarm() {
      return this.showByFarm && this.userLevel == 'pecsmart' ? 'select-toggle' : ''
    },
    colorSelectCompanies() {
      return this.showByCompanies && this.userLevel == 'pecsmart' ? 'select-toggle' : ''
    },
    selectedFarmByCompanies() {
      return this.filterCompanies(this.option)
    },
    isPamplonaCompanyAdmin() {
      // TODO: Change this to get information from the backend about using the button or not
      const user = this.$store.getters.getCurrentUser

      return user.company === 4 && user.role === "company_admin"
    },
    loadingTotal() {
      return this.$store.getters.getActiveRequest
    },
    userLevel() {
      return this.$store.getters.getUserLevel
    },
    pamplonaBiUrl() {
      // TODO: Change this to get URL for the BI from the backend
      return 'https://app.powerbi.com/view?r=eyJrIjoiMjhkZmU1YzktNmJiOC00Y2FkLTk1NWQtM2ZlMDcwMWViMzg3IiwidCI6Ijk2ODlhOGFmLWI4NjItNDZiMS04MWYzLTAzNjA2NjkzZTBjMSJ9&pageName=ReportSection713ed991c08e7816670a'
    },
    selectedFarm() {
      return this.selectedFarms && this.selectedFarms.length > 0 ? this.selectedFarms[0] : null;
    },
    selectedCompany() {
      if (!this.selectedFarm) return null;
      return this.companies.find(company => company.pk === this.selectedFarm.company);
    },
    optionCompanies: {
      get() {
        return this.$store.getters.getSelectedCompany || 'Companies'
      },
      set(value) {
        this.$store.commit('setSelectedCompany', value)
      }
    },
    optionFarm: {
      get() {
        return this.$store.getters.getSelectedFarm || 'Todas as Granjas'
      },
      set(value) {
        this.$store.commit('setSelectedFarm', value)
      }
    },
    optionFarmPecsmart: {
      get() {
        return this.$store.getters.getSelectedFarmPecsmart || 'Pecsmart Support'
      },
      set(value) {
        this.$store.commit('setSelectedFarmPecsmart', value)
      }
    },
    showByFarm: {
      get() {
        return this.$store.getters.getShowByFarm
      },
      set(value) {
        this.$store.commit('setShowByFarm', value)
      }
    },
    showByCompanies: {
      get() {
        return this.$store.getters.getShowByCompanies
      },
      set(value) {
        this.$store.commit('setShowByCompanies', value)
      }
    },

  },
  methods: {
    isSiloHomeFarm(farm) {
      const farmPk = getFarmPk(farm);
      const cachedBarns = farmPk
        ? this.$store.getters.getCachedHomeFarmBarns(farmPk) || []
        : [];
      return isSiloHomeEnabledForFarm(this.companySettings, farm, cachedBarns);
    },
    wait(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms))
    },
    async bootstrapHomeData() {
    // Keep in-memory home caches when navigating back from details.
    // Full clean is only needed before a fresh login bootstrap.
    if (this.status === false) {
      this.$store.commit('cleanData')
      if (this.userLevel === 'pecsmart') {
        this.$store.commit('cleanFazendas')
      }
    }
    if ((typeof window.localStorage.getItem("username") === typeof 'string') && (this.status === false)) {
      this.$store.commit("setNavbar", true)
      const user = {
        username: window.localStorage.getItem("username")
      }
      const isLoginPage = false
      await this.$store.commit("setHeader", window.localStorage.getItem("Token"))
      await this.$store.dispatch("login", {user, isLoginPage})
      this.$store.commit("setLogStatus", true)

      if (this.userLevel !== 'pecsmart') {
        await this.$store.dispatch("fetchCompanySettings", this.company)
        if (this.feedInventoryOnly) return
      }

      await this.$store.dispatch("startHome")

      if (this.userLevel !== 'pecsmart') await this.$store.dispatch("fetchFoodByCompany", this.company)
      if (this.userLevel !== 'pecsmart') this.$store.commit('setTargetCompany', this.company);
      if (this.userLevel == 'pecsmart') await this.$store.dispatch("fetchCompanies")
    }
    else {
      if (this.status === true) {
        return
      }
      else {
        await this.$store.dispatch("startHome")
        this.$router.push('/')
      }
    }
    },
    closeModal() {
      this.showModalBarn = false
      this.showModalFarm = false
    },
    updateOption(value) {
      this.optionSelected = value
    },
    filterCompanies(value) {
      return this.allFarms.filter((farm)=>{
        return farm.company == value.pk
      })
    },
    filterFarm(value) {
      return this.allFarms.filter((farm)=>{
        return farm.name == value.name
      })
    }
  },
  watch:{
    optionCompanies (newValue) {
      if (newValue !== 'Companies') {
        this.showByFarm = false
        this.showByCompanies = true
        this.optionFarmPecsmart = 'Pecsmart Support'
        if (newValue.pk) {
          this.$store.dispatch('fetchCompanySettings', newValue.pk);
          this.$store.dispatch('fetchFoodByCompany', newValue.pk);
          this.$store.commit('setTargetCompany', newValue.pk);
        }
      }
     
    },
    optionFarm () {
      this.showByFarm = true
      this.showByCompanies = false
    },
    optionFarmPecsmart (newValue) {
      if (newValue !== 'Pecsmart Support') {
        this.showByFarm = true
        this.showByCompanies = false
        this.optionCompanies = 'Companies'
        if (newValue.company) {
          this.$store.dispatch('fetchCompanySettings', newValue.company);
          this.$store.dispatch('fetchFoodByCompany', newValue.company);
          this.$store.commit('setTargetCompany', newValue.company);
        }
      }
    },
  }
};
</script>

<style scoped>
.page-animation {
  animation:down 0.5s ease;
  padding: 0px;
}

.content-reveal-enter-active {
  transition: opacity 0.45s ease, transform 0.45s ease;
}

.content-reveal-enter {
  opacity: 0;
  transform: translateY(18px);
}

.cursor{
  cursor: not-allowed;
}

.message{
  font-size: 20px;
  font-weight: bold;
  text-align: center;
}

.container{
  margin: auto;
}

@keyframes down {
  0% {
    opacity: 0;
    transform:translateY(-50px);
  }
  100% {
    opacity: 1;
    transform:translateY(0px);
  }
}

.galpoes .rTable3 {
  margin-bottom: 30px;
}

.galpoes .rTable3:last-child {
  margin-bottom: 0;
}

.select-companies{
  min-width: 220px;
  max-width: 280px;
}

.select-toggle{
  border: 4px solid #1b4238;
  color: #1b4238;
  font-weight: 600;
}

.users-header-icon {
  color: #fff;
  font-size: 18px;
  padding: 0 8px 0 0;
}

.header-buttons{
  display: flex;
  flex-direction: column;
  gap: 24px;
  align-items: center;
}

@media screen and (min-width: 991px) {
  .header-buttons{
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    gap: 12px;
    align-items: center;
  }
}



</style>